import React from 'react';
import {ComingSoon} from 'components';
import {ScrollView, StyleSheet} from 'react-native';

export function StoryComments() {
  return (
    <ScrollView contentContainerStyle={styles.scrollContainer} showsVerticalScrollIndicator={false}>
      <ComingSoon
        text="Collaborate with your team in real-time by sharing updates and feedback."
        imageSource={require('assets/illustrations/coming-soon-comments.png')}
      />
    </ScrollView>
  );
}

const styles = StyleSheet.create({
  scrollContainer: {
    flex:1
  }
})